import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SavedProvider } from "@/context/SavedContext";

import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import PartnerWithUs from "@/pages/PartnerWithUs";
import Referral from "@/pages/Referral";
import Agencies from "@/pages/Agencies";
import AgencyDetail from "@/pages/AgencyDetail";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Contact from "@/pages/Contact";
import SavedProperties from "@/pages/SavedProperties";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminLayout from "@/components/admin/AdminLayout";
import Login from "@/pages/admin/Login";
import ResetPassword from "@/pages/admin/ResetPassword";
import Dashboard from "@/pages/admin/Dashboard";
import AdminProperties from "@/pages/admin/AdminProperties";
import PropertyForm from "@/pages/admin/PropertyForm";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import EnquiryDetail from "@/pages/admin/EnquiryDetail";
import AdminAgencies from "@/pages/admin/AdminAgencies";
import AdminReferrals from "@/pages/admin/AdminReferrals";
import AdminBlog from "@/pages/admin/AdminBlog";
import BlogForm from "@/pages/admin/BlogForm";
import EmailPreview from "@/pages/admin/EmailPreview";
import AdminInbox from "@/pages/admin/AdminInbox";
import AdminSettings from "@/pages/admin/AdminSettings";
import ActivityLog from "@/pages/admin/ActivityLog";
import AdminUsers from "@/pages/admin/AdminUsers";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SavedProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/properties" element={<Properties />} />
                <Route path="/properties/for-sale" element={<Properties listing="sale" />} />
                <Route path="/properties/to-let" element={<Properties listing="let" />} />
                <Route path="/featured" element={<Properties featuredOnly />} />
                <Route path="/property/:slug" element={<PropertyDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/partner" element={<PartnerWithUs />} />
                <Route path="/referral-information" element={<Referral />} />
                <Route path="/agencies" element={<Agencies />} />
                <Route path="/agencies/:slug" element={<AgencyDetail />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogArticle />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/saved" element={<SavedProperties />} />
                <Route path="/privacy-policy" element={<Legal page="privacy" />} />
                <Route path="/terms" element={<Legal page="terms" />} />
                <Route path="/cookie-policy" element={<Legal page="cookies" />} />
                <Route path="/disclaimer" element={<Legal page="disclaimer" />} />
                <Route path="/complaints" element={<Legal page="complaints" />} />
                <Route path="*" element={<NotFound />} />
              </Route>

              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="properties" element={<AdminProperties />} />
                <Route path="properties/new" element={<PropertyForm />} />
                <Route path="properties/:id" element={<PropertyForm />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
                <Route path="enquiries/:id" element={<EnquiryDetail />} />
                <Route path="referrals" element={<AdminReferrals />} />
                <Route path="agencies" element={<AdminAgencies />} />
                <Route path="blog" element={<AdminBlog />} />
                <Route path="blog/new" element={<BlogForm />} />
                <Route path="blog/:id" element={<BlogForm />} />
                <Route path="emails" element={<EmailPreview />} />
                <Route path="inbox" element={<AdminInbox />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="activity" element={<ActivityLog />} />
                <Route path="users" element={<AdminUsers />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </SavedProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
